(function () {
  var widgets = document.querySelectorAll('[data-ogc-support-widget]');

  if (!widgets.length) {
    return;
  }

  function parseTime(value) {
    var parts = String(value || '').split(':');
    var hours = Number(parts[0]);
    var minutes = Number(parts[1]);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return null;
    }

    return (hours * 60) + minutes;
  }

  function getZonedParts(timezone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone || 'Asia/Singapore',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });

    var parts = formatter.formatToParts(new Date()).reduce(function (acc, part) {
      acc[part.type] = part.value;
      return acc;
    }, {});

    var dayMap = {
      Mon: 'mon',
      Tue: 'tue',
      Wed: 'wed',
      Thu: 'thu',
      Fri: 'fri',
      Sat: 'sat',
      Sun: 'sun'
    };

    return {
      day: dayMap[parts.weekday] || '',
      minutes: (Number(parts.hour) * 60) + Number(parts.minute)
    };
  }

  function isWithinSchedule(widget) {
    if (widget.dataset.whatsappEnabled !== 'true') {
      return false;
    }

    var start = parseTime(widget.dataset.whatsappStart);
    var end = parseTime(widget.dataset.whatsappEnd);

    if (start === null || end === null) {
      return true;
    }

    var activeDays = String(widget.dataset.whatsappDays || '')
      .toLowerCase()
      .split(',')
      .map(function (day) {
        return day.trim();
      })
      .filter(Boolean);

    var current;

    try {
      current = getZonedParts(widget.dataset.timezone);
    } catch (error) {
      current = getZonedParts('Asia/Singapore');
    }

    if (activeDays.length && activeDays.indexOf(current.day) === -1) {
      return false;
    }

    if (start === end) {
      return true;
    }

    if (start < end) {
      return current.minutes >= start && current.minutes < end;
    }

    return current.minutes >= start || current.minutes < end;
  }

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

    function renderArticles(widget, articles, query, activeCategory) {
        var helpResults = widget.querySelector('[data-ogc-support-help-results]');
        var blogResults = widget.querySelector('[data-ogc-support-blog-results]');
        var helpSection = widget.querySelector('[data-ogc-support-help-section]');
        var blogSection = widget.querySelector('[data-ogc-support-blog-section]');
        var empty = widget.querySelector('[data-ogc-support-empty]');

        if (!helpResults || !blogResults) {
            return;
        }

        var normalizedQuery = normalize(query);
        var normalizedCategory = normalize(activeCategory);

        var filtered = articles.filter(function (article) {
            var matchesSearch =
            !normalizedQuery ||
            normalize(article.title).indexOf(normalizedQuery) !== -1 ||
            normalize(article.excerpt).indexOf(normalizedQuery) !== -1 ||
            normalize(article.category).indexOf(normalizedQuery) !== -1;

            var matchesCategory =
            !normalizedCategory ||
            normalizedCategory === 'all' ||
            normalize(article.category) === normalizedCategory;

            return matchesSearch && matchesCategory;
        });

        var helpArticles = filtered.filter(function (article) {
        return article.source === 'faq' || article.source === 'manual';
        }).slice(0, 5);

        var blogArticles = filtered.filter(function (article) {
            return article.source === 'one-good-blog';
        }).slice(0, 4);

        function createMarkup(articleList) {
            return articleList.map(function (article) {
            var title = escapeHtml(article.title || 'Help article');
            var excerpt = escapeHtml(article.excerpt || '');
            var category = escapeHtml(article.category || '');
            var url = escapeHtml(article.url || '#');

            return [
                '<a class="ogc-support-widget__result" href="' + url + '" target="_blank" rel="noopener">',
                '<span>',
                    category
                    ? '<span class="ogc-support-widget__result-category">' + category + '</span>'
                    : '',
                    '<strong>' + title + '</strong>',
                    excerpt
                    ? '<small>' + excerpt + '</small>'
                    : '',
                '</span>',
                '<i data-lucide="chevron-right" aria-hidden="true"></i>',
                '</a>'
            ].join('');
            }).join('');
        }

        helpResults.innerHTML = createMarkup(helpArticles);
        blogResults.innerHTML = createMarkup(blogArticles);

        if (helpSection) {
            helpSection.hidden = helpArticles.length === 0;
        }

        if (blogSection) {
            blogSection.hidden = blogArticles.length === 0;
        }

        if (empty) {
            empty.hidden = helpArticles.length > 0 || blogArticles.length > 0;
        }

        if (window.lucide) {
            window.lucide.createIcons();
        }
    }

    function renderCategoryFilters(widget, articles, activeCategory, onChange) {
        var filterContainer = widget.querySelector('[data-ogc-support-filters]');

        if (!filterContainer) {
            return;
        }

        var seen = {};
        var categories = [];

        articles.forEach(function (article) {
            var category = String(article.category || '').trim();
            var key = normalize(category);

            if (category && !seen[key]) {
            seen[key] = true;
            categories.push(category);
            }
        });

        var faqOrder = [
          'General',
          'Corporate',
          'Features & Usage',
          'Order & Shipping',
          'Payments'
        ];

        categories.sort(function (a, b) {
          var aIndex = faqOrder.indexOf(a);
          var bIndex = faqOrder.indexOf(b);

          var aIsFaq = aIndex !== -1;
          var bIsFaq = bIndex !== -1;

          // FAQ categories first
          if (aIsFaq && bIsFaq) {
            return aIndex - bIndex;
          }

          if (aIsFaq) {
            return -1;
          }

          if (bIsFaq) {
            return 1;
          }

          // Blog categories afterwards, alphabetically
          return a.localeCompare(b);
        });

        var filters = ['All'].concat(categories);

        filterContainer.innerHTML = filters.map(function (category) {
            var isActive = normalize(category) === normalize(activeCategory);

            return [
            '<button',
                ' type="button"',
                ' class="ogc-support-widget__filter' + (isActive ? ' is-active' : '') + '"',
                ' data-ogc-support-filter="' + escapeHtml(category) + '"',
                ' aria-pressed="' + (isActive ? 'true' : 'false') + '"',
            '>',
                escapeHtml(category),
            '</button>'
            ].join('');
        }).join('');

        filterContainer.querySelectorAll('[data-ogc-support-filter]').forEach(function (button) {
            button.addEventListener('click', function () {
            onChange(button.dataset.ogcSupportFilter || 'All');
            });
        });
    }

  widgets.forEach(function (widget) {
    var toggle = widget.querySelector('[data-ogc-support-toggle]');
    var closeButtons = widget.querySelectorAll('[data-ogc-support-close]');
    var panel = widget.querySelector('.ogc-support-widget__panel');
    var backdrop = widget.querySelector('.ogc-support-widget__backdrop');
    var search = widget.querySelector('[data-ogc-support-search]');
    var articleScript = widget.querySelector('[data-ogc-support-articles]');
    var whatsappLink = widget.querySelector('[data-ogc-whatsapp-link]');
    var statusText = widget.querySelector('[data-ogc-whatsapp-status-text]');
    var articles = [];
    var activeCategory = 'All';
    var currentQuery = '';

    try {
      articles = JSON.parse(articleScript ? articleScript.textContent : '[]');
    } catch (error) {
      articles = [];
    }

    function slugify(value) {
    return String(value || '')
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function refreshWidget() {
      renderCategoryFilters(
        widget,
        articles,
        activeCategory,
        selectCategory
      );

      renderArticles(
        widget,
        articles,
        currentQuery,
        activeCategory
      );
    }

    function extractFaqArticlesFromHtml(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var faqUrl = '/blogs/help-center/frequently-asked-questions';
      var faqItems = [];
      var currentCategory = 'General';

      function cleanText(value) {
        return String(value || '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      var articleRoot =
        doc.querySelector('[itemprop="articleBody"]') ||
        doc.querySelector('.article__content') ||
        doc.querySelector('.rte') ||
        doc.querySelector('article') ||
        doc.querySelector('main');

      if (!articleRoot) {
        console.warn('OGC FAQ: article content container not found');
        return [];
      }

      var sections = articleRoot.querySelectorAll(
        'h2, details.hc-faq-item'
      );

      sections.forEach(function (element) {
        if (element.tagName === 'H2') {
          currentCategory = cleanText(element.textContent);
          return;
        }

        var question = element.querySelector('.hc-faq-q');
        var answer = element.querySelector('.hc-faq-a');

        if (!question) {
          return;
        }

        var anchor = element.id
          ? '#' + element.id
          : '';

        faqItems.push({
          title: cleanText(question.textContent),
          excerpt: cleanText(
            answer ? answer.textContent : ''
          ).slice(0, 280),
          url: faqUrl + anchor,
          category: currentCategory,
          source: 'faq'
        });
      });

      console.log('OGC FAQ parsed items:', faqItems);

      return faqItems;
    }

    function openWidget() {
      widget.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');

      if (backdrop) {
        backdrop.hidden = false;
      }

      window.setTimeout(function () {
        if (search) {
          search.focus();
        }
      }, 120);
    }

    function closeWidget() {
      widget.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');

      if (backdrop) {
        backdrop.hidden = true;
      }
    }

    function updateAvailability() {
      var available = isWithinSchedule(widget);
      widget.classList.toggle('is-whatsapp-offline', !available);

      if (whatsappLink) {
        whatsappLink.setAttribute('aria-disabled', available ? 'false' : 'true');
        whatsappLink.tabIndex = available ? 0 : -1;
      }

      if (!available && statusText) {
        statusText.textContent = widget.dataset.whatsappDisabledMessage || 'WhatsApp is currently offline.';
      } else if (available && statusText) {
        statusText.textContent = widget.dataset.whatsappOnlineMessage || 'We are online';
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (widget.classList.contains('is-open')) {
          closeWidget();
        } else {
          openWidget();
        }
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeWidget);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && widget.classList.contains('is-open')) {
        closeWidget();
      }
    });

    if (search) {
        search.addEventListener('input', function (event) {
            currentQuery = event.target.value;

            renderArticles(
            widget,
            articles,
            currentQuery,
            activeCategory
            );
        });
    }

    function selectCategory(category) {
    activeCategory = category || 'All';

    renderCategoryFilters(
        widget,
        articles,
        activeCategory,
        selectCategory
    );

    renderArticles(
        widget,
        articles,
        currentQuery,
        activeCategory
    );
    }

    refreshWidget();

    fetch('/blogs/help-center/frequently-asked-questions')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('FAQ request failed: ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var faqArticles = extractFaqArticlesFromHtml(html);

        console.log('OGC FAQ articles found:', faqArticles.length);

        articles = faqArticles.concat(articles);

        refreshWidget();
      })
      .catch(function (error) {
        console.warn('OGC support widget FAQ load failed:', error);
      });

    updateAvailability();
    window.setInterval(updateAvailability, 60000);
  });

  if (window.lucide) {
    window.lucide.createIcons();
  } else {
    window.addEventListener('load', function () {
      if (window.lucide) {
        window.lucide.createIcons();
      }
    });
  }
})();
